export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const SET_ALERT = "SET_ALERT";
export const DELETE_ALERT = "DELETE_ALERT";
export const DELETE_ALL_ALERT = "DELETE_ALL_ALERT";
export const ADMIN_LOADED = "ADMIN_LOADED";
export const AUTH_FAIL = "AUTH_FAIL";
export const LOGOUT = "LOGOUT";
export const ADMIN_UPDATE_SUCCESS = "ADMIN_UPDATE_SUCCESS";
export const ADMIN_UPDATE_FAIL = "ADMIN_UPDATE_FAIL";
export const ADMIN_UPDATE_REQUEST = "ADMIN_UPDATE_REQUEST";

//SubAdmin
export const SUBADMIN_LIST = "SUBADMIN_LIST";
export const GET_PERMISSIONS = "GET_PERMISSIONS";
export const PERMISSION_SUCCESS = "PERMISSION_SUCCESS";
export const PERMISSION_FAIL = "PERMISSION_FAIL";
export const RESET_PERMISSIONS = "RESET_PERMISSIONS";
export const GET_PERMISSIONS_FLAG = "GET_PERMISSIONS_FLAG";
export const FAIL_PERMISSIONS_FLAG = "GET_PERMISSIONS_FLAG";

// TP Users
export const TP_USERS_LIST = "TP_USERS_LIST";
export const TP_USERS_LIST_LOADING = "TP_USERS_LIST_LOADING";
export const TP_USERS_LIST_FAILD = "TP_USERS_LIST_FAILD";
export const GET_TP_LEADS = "GET_TP_LEADS";
export const GET_TP_LEADS_LOADING = "GET_TP_LEADS_LOADING";
export const GET_TP_LEADS_ERROR = "GET_TP_LEADS_ERROR";

// MEDIA LIST
export const ALL_MEDIA_LIST = "ALL_MEDIA_LIST";

// ROLE 
export const ROLE_LIST = "ROLE_LIST";

// GET ALL LEADS
export const GET_ALL_LEADS = "GET_ALL_LEADS";
export const GET_ALL_LEADS_LOADING = "GET_ALL_LEADS_LOADING";
export const LEADS_LOADING = "LEADS_LOADING ";


// GET ALL LEADS
export const GET_AMPERE_LEADS = "GET_AMPERE_LEADS";
export const GET_AMPERE_LEADS_LOADING = "GET_AMPERE_LEADS_LOADING";
export const GET_AMPERE_LEADS_FAILD = "GET_AMPERE_LEADS_FAILD";

// GET COMBINATIONS
export const GET_BRAND_COMBINATION_LIST = "GET_BRAND_COMBINATION_LIST";
export const GET_BRAND_COMBINATION_LIST_LOADING = "GET_BRAND_COMBINATION_LIST_LOADING";
export const GET_BRAND_COMBINATION_LIST_FAILD = "GET_BRAND_COMBINATION_LIST_FAILD";

export const GET_SOURCE_COMBINATION_LIST = "GET_SOURCE_COMBINATION_LIST";
export const GET_SOURCE_COMBINATION_LIST_LOADING = "GET_SOURCE_COMBINATION_LIST_LOADING";
export const GET_SOURCE_COMBINATION_LIST_FAILD = "GET_SOURCE_COMBINATION_LIST_FAILD";

export const GET_SUB_SOURCE_COMBINATION_LIST = "GET_SUB_SOURCE_COMBINATION_LIST";
export const GET_SUB_SOURCE_COMBINATION_LIST_LOADING = "GET_SUB_SOURCE_COMBINATION_LIST_LOADING";
export const GET_SUB_SOURCE_COMBINATION_LIST_FAILD = "GET_SUB_SOURCE_COMBINATION_LIST_FAILD";

// GET OEM HISTORY
export const OEM_HISTORY_REQUEST = "OEM_HISTORY_REQUEST";
export const OEM_HISTORY_SUCCESS = "OEM_HISTORY_SUCCESS";
export const OEM_HISTORY_FAIL = "OEM_HISTORY_FAIL";

// GET DIALSHREE LEADS
export const GET_DIALSHREE_LEADS = "GET_DIALSHREE_LEADS";
export const GET_DIALSHREE_LEADS_LOADING = "GET_DIALSHREE_LEADS_LOADING";
export const GETDIALSHREE_LEADS_FAILD = "GETDIALSHREE_LEADS_FAILD";

// GET DIALSHREE INBOUND CALL LEADS
export const GET_DIALSHREE_INBOUND_LEADS = "GET_DIALSHREE_INBOUND_LEADS";
export const GET_DIALSHREE_INBOUND_LEADS_LOADING = "GET_DIALSHREE_INBOUND_LEADS_LOADING";
export const GETDIALSHREE_INBOUND_LEADS_FAILD = "GETDIALSHREE_INBOUND_LEADS_FAILD";